function validateEmptyRichText(htmlString?: string): boolean {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString || '';
  const content = tempDiv.textContent || tempDiv.innerText || '';
  return !content;
}

export default validateEmptyRichText;
